// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appointment-slot[data-v-60afaaa1]{margin:5px 0}`, "",{"version":3,"sources":["webpack://./src/components/Appointments/AppointmentSlot.vue"],"names":[],"mappings":"AACA,mCACC,YAAA","sourcesContent":["\n.appointment-slot {\n\tmargin: 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
